import { Link } from '@inertiajs/react'

export default function QuickActions() {
  const actions = [
    { label: 'Nouveau lead', href: '/leads/new', icon: '➕', color: 'blue' },
    { label: 'Nouvelle propriété', href: '/properties/new', icon: '🏠', color: 'green' }
  ]

  return (
    <div className="flex gap-3">
      {actions.map((action) => (
        <Link
          key={action.href}
          href={action.href}
          className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors ${
            action.color === 'blue'
              ? 'bg-primary-600 text-white hover:bg-primary-700'
              : 'bg-green-600 text-white hover:bg-green-700'
          }`}
        >
          <span>{action.icon}</span>
          <span>{action.label}</span>
        </Link>
      ))}
    </div>
  )
}
